import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { ArrowLeft, ArrowRight } from "lucide-react";
import Layout from "@/components/layout/Layout";
import { api } from "@/lib/api";

export default function BlogArticle() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    setPost(null);
    setNotFound(false);
    api.get(`/blog/${slug}`)
      .then((r) => setPost(r.data))
      .catch(() => setNotFound(true));
  }, [slug]);

  if (notFound) {
    return (
      <Layout>
        <section className="py-40 text-center">
          <h1 className="heading-section">Article not found</h1>
          <Link to="/blog" className="btn-secondary mt-8 inline-flex">Back to blog</Link>
        </section>
      </Layout>
    );
  }
  if (!post) {
    return (
      <Layout>
        <div className="py-40 text-center text-tratou-dim font-mono text-sm" data-testid="article-loading">Loading...</div>
      </Layout>
    );
  }
  return (
    <Layout>
      <article data-testid="blog-article">
        <section className="py-20 border-b border-white/10">
          <div className="max-w-3xl mx-auto px-6 lg:px-10">
            <Link to="/blog" className="inline-flex items-center gap-2 text-tratou-dim hover:text-tratou-green font-mono text-xs uppercase tracking-[0.18em]" data-testid="article-back">
              <ArrowLeft className="w-3.5 h-3.5" /> All articles
            </Link>
            <p className="eyebrow mt-8">{post.category} · {post.read_time}</p>
            <h1 className="heading-massive mt-4">{post.title}</h1>
            <p className="mt-6 text-tratou-dim text-lg">{post.excerpt}</p>
            <p className="mt-6 font-mono text-xs uppercase tracking-[0.18em] text-tratou-faint">By {post.author}</p>
          </div>
        </section>

        <section className="py-12">
          <div className="max-w-3xl mx-auto px-6 lg:px-10">
            <div className="aspect-[16/9] overflow-hidden panel">
              <img src={post.cover_image} alt={post.title} className="w-full h-full object-cover" />
            </div>
            <div className="mt-12 prose prose-invert max-w-none">
              {post.content.split("\n\n").map((para, i) => (
                <p key={i} className="text-tratou-dim text-lg leading-relaxed mb-6">{para}</p>
              ))}
            </div>
          </div>
        </section>

        <section className="py-20 border-t border-white/10 text-center">
          <div className="max-w-xl mx-auto px-6">
            <h3 className="heading-section">Ready to deploy?</h3>
            <p className="mt-4 text-tratou-dim">Get a tailored MBESS proposal in under 24 hours.</p>
            <Link to="/contact?intent=quote" className="btn-primary mt-8" data-testid="article-cta">
              Request a Quote <ArrowRight className="w-4 h-4" />
            </Link>
          </div>
        </section>
      </article>
    </Layout>
  );
}
